import { DemoNotice, Empty, PageHead, Spinner, StatusBadge, useFetch } from "@/components/common";
import { PackageQR } from "@/components/PackageQR";

export default function QRCodes() {
  const { data, loading } = useFetch("/admin/packages");
  const settings = useFetch("/admin/settings");
  return (
    <div className="space-y-6">
      <PageHead eyebrow="QR code management" title="Standard package QR codes" sub="One QR per package, shared by all physical cards of that package. Print it on card sleeves and posters." />
      <DemoNotice>QR links use {settings.data?.public_base_url || window.location.origin}. Set your final domain in Settings before printing.</DemoNotice>
      {loading && <Spinner />}
      {data?.length === 0 && <Empty title="No packages" />}
      <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
        {data?.map((p) => (
          <div key={p.id} className="surface flex flex-col items-center gap-3 p-6">
            <div className="flex w-full items-center justify-between"><p className="font-bold">{p.name}</p><StatusBadge status={p.status} /></div>
            <PackageQR pkg={p} base={settings.data?.public_base_url} />
            {p.status !== "ACTIVE" && <p className="text-[11px] text-amber-700">Package is not ACTIVE — the enrollment page will show “not offered”.</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
